/**
 * 输出一个有效地时间戳
 * @param {timestamp} time 时间戳
 */
function timestamp (time) {
  if (!time) {
    return 0
  }

  if (typeof time === 'object') {
    time = Date.now()
  }

  if (typeof time === 'string' && !/^\d+$/gi.test(time)) {
    // 兼容 safari Date 格式 只能是 YYYY/MM/DD
    time = time.replace(/-/g, '/')

    try {
      time = (new Date(time)).getTime()

      if (time) {
        return time
      }
    } catch (e) { }
  }

  if (time) {
    time += ''

    if (time.length < 12) {
      // const length = 13 - time.length
      // time = time * Math.pow(10, length > 1 ? length : 0)

      // 在确认为秒的时候，固定为 3 位
      time = time + '000'
    }

    return time - 0
  }

  return 0
}

export default timestamp
